import { defineStore } from 'pinia'
import axios from 'axios'
import { useLangStore } from './langStore'

export const usePortfolioPageStore = defineStore('portfolioPage', {
    state: () => ({
        portfolio: {
            data: []
        },
        isLoading: false
    }),
    getters: {
        // Dile göre filtrelenmiş liste
        filteredImages: (state) => {
            const lang = useLangStore().language;
            return state.portfolio.data.map(item => ({
                imageName: item.imageName,
                imageInfo: lang === 'tr' ? item.imageInfo_TR : item.imageInfo_EN
            }));
        }
    },
    actions: {
        async fetchPortfolioData(){
            if (this.portfolio.data.length > 0) return;
            this.isLoading = true;
            try{
                const res = await axios.get('/api-path/Portfolio/get-all-images');
                this.portfolio.data = res.data.data;
            } catch (err) {
                console.log(err);
            } finally {
                this.isLoading = false;
            }
        }
    }
});